




















































































































































































import _, { keyBy } from "lodash";
import { UIModel } from "../../UIModel";
import { Prop, Component, Vue, Ref } from "vue-property-decorator";
import { BIM360IssueStatus, BIM360Issue } from '@/model/BIM360Issue';
import { FrontendBIM360Issue } from '@/model/frontend/FrontendBIM360Issue';
import { Mentionable } from "vue-mention";
import { MentionableUser } from "../../model/frontend/MentionableUser";
import * as moment from 'moment-timezone';
// Imports Child Components
import NewIssuePreviewModal from "./new_issue_preview_modal.vue";
import BulkField from "../bulkfield.vue";
import BulkFieldWithTokens from "../bulkfieldwithtokens.vue";
import { BulkIssueTemplate } from '../../model/frontend/BulkIssueTemplate';
import { classToClass } from 'class-transformer';

@Component({
	components: {
		NewIssuePreviewModal,
		BulkField,
        BulkFieldWithTokens,
        Mentionable
	},
})
export default class IssueModal extends Vue {
	// Props
	@Prop({ required: true }) public model!: UIModel;

	@Prop({ required: true }) public isNew!: boolean;

    @Prop({ required: false }) public editIssues!: FrontendBIM360Issue[];
    
	@Ref() public previewModal!: NewIssuePreviewModal;
	
	// Data
    public show: boolean = false;
    private mentionableUsers: MentionableUser[] = [];
	private displayComment : string = "";

    get mentionableUserOptions(): any {
        return this.mentionableUsers.map(m => m.GetMentionableUserOption());
    }
    
    set commentsText(text: string) {
        const regex = /@([a-z-\d]+)/gm;

        this.displayComment = text;

        this.model.issueComment = this.displayComment.replace(regex, (match) => {
            let user = this.mentionableUsers.find(u => (u.mentionableValue == match.substr(1)));
            return `@{"type": "user", "id": "${user?.id}", "name": "${user?.name}"}`
        });

        this.model.newIssueTemplate.comment.value = this.displayComment;
    }

    get commentsText(): string {
        return this.displayComment;
    }

	// Getters
	get newIssueStatusesAvailable(): any {
		return [BIM360IssueStatus.Draft, BIM360IssueStatus.Open];
	}

	get isMobile(): boolean {
		if (window) {
			return window.innerWidth < 768;
		} else {
			return false;
		}
	}

	// Mounted
	public mounted() {
		// Set default status
        this.model.newIssueTemplate.status.value = BIM360IssueStatus.Draft;

		// Set default assignee and owner TODO: Is this even neccessary, why not just assign to this.model.user.forgeID?
		if (this.model.projectUsers && this.model.user){
            this.model.newIssueTemplate.assignedTo.value = this.model.projectUsers[this.model.user.forgeID].forgeID;
            this.model.newIssueTemplate.owner.value = this.model.projectUsers[this.model.user.forgeID].forgeID;
        }
	}

	// Methods

	public open(): void {
        this.show = true;
        
        // Creates the mentionable users for the comments
        let mentionableUsers = [];
        if(this.model.projectUsers) {
            let userArray = Object.values(this.model.projectUsers);
            this.mentionableUsers = userArray.map(u => {
                let mentionableUser = new MentionableUser(u.name);
                mentionableUser.id = u.forgeID;
                return mentionableUser;
            });
        }
    }
    
	public getFriendlyName(status: BIM360IssueStatus) {
		return BIM360Issue.friendlyNameForStatus(status);
	}

	public onPreviewClosed(didFinish: boolean): void {
		if (didFinish)
		{
            this.show = false;
            this.displayComment = "";
		}
	}
	
	public cancel(): void {
		this.model.newIssueTemplate = new BulkIssueTemplate(new FrontendBIM360Issue(), this.model);
		this.model.newIssueArray = [];
        this.model.issueComment = "";
        this.displayComment = "";
		this.show = false;
	}

	public preview(): void {
		// Do some stuff
		console.log("Batch creating issues!");
		this.model.newIssueArray = [];
		const timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
		if (this.isNew)
		{
			for (let i = 0; i < this.model.newIssueCount; i++) {
				// Creates the new issue instance
				const new_issue = new FrontendBIM360Issue();
				new_issue.id = this.model.newIssueTemplate.id.value;
				new_issue.title = this.model.newIssueTemplate.title.forIteration(i + 1);
				new_issue.description = this.model.newIssueTemplate.description.forIteration(i + 1);
				new_issue.status = this.model.newIssueTemplate.status.value;
				new_issue.issueSubtypeId = this.model.newIssueTemplate.issueSubtypeId.value;
				new_issue.assignedTo = this.model.newIssueTemplate.assignedTo.value;
				new_issue.locationDescription = this.model.newIssueTemplate.locationDescription.forIteration(i + 1);
				new_issue.owner = this.model.newIssueTemplate.owner.value;
				new_issue.dueDate = this.model.newIssueTemplate.dueDate.value;
				if(this.model.newIssueTemplate.dueDate.value)
				{
					new_issue.dueDateString = moment.tz(this.model.newIssueTemplate.dueDate.value, timeZone).format('YYYY-MM-DD');	
				}
				new_issue.rootCauseId = this.model.newIssueTemplate.rootCauseId.value;
				this.model.newIssueArray.push(new_issue);
			}
		}
		else
		{
			for (let issue of this.editIssues)
			{
				const new_issue = this.model.newIssueTemplate.applyBulkEdit(issue);
				if(this.model.newIssueTemplate.dueDate.value)
				{
					new_issue.dueDateString = moment.tz(this.model.newIssueTemplate.dueDate.value, timeZone).format('YYYY-MM-DD');
				}
				this.model.newIssueArray.push(new_issue);
			}
		}
		this.previewModal.open();
	}

	public checkPermittedAttrForEdit(propertyName): boolean 
	{
		const allPermittedAttrArray = _.map(this.editIssues, 'permittedAttributes');
		const availableProperties = _.intersection(...allPermittedAttrArray);
		if(availableProperties.includes(propertyName)) return true;
		return false;
	}

	public isShow(propertyName)
	{
		if(this.isNew) return true;
		if(this.checkPermittedAttrForEdit(propertyName)) return true;
		return false;
	}

	public getAvailableProjectNGIssueTypes() 
	{
		if(this.isNew) return this.model.projectNGIssueTypes;
		//check edit issues intersection permitted propeties
		const canEditNgType = this.checkPermittedAttrForEdit('issueTypeId');
		const canEditNgSubType = this.checkPermittedAttrForEdit('issueSubtypeId');
		if(!canEditNgType && canEditNgSubType) 
		{
			//check if issues have same ng_type
			const isAllSameNgType = this.checkPropertiesHaveSameValue(this.editIssues, 'issueTypeId');
			if(isAllSameNgType)return [this.model.projectNGIssueTypesDict[this.editIssues[0].issueTypeId]];
			return [];
		}
		return this.model.projectNGIssueTypes;
	}

	public showEditType()
	{
		if(this.isNew) return true;
		if(this.checkPermittedAttrForEdit('issueSubtypeId')) 
		{
			const permittedTypes = this.getAvailableProjectNGIssueTypes();
			if(!permittedTypes.length) return false;
			return true;
		}
		return false;
	}

	private checkPropertiesHaveSameValue(objectArray: Array<any>, property: string) 
	{	
		if(!objectArray) return false;
		const theValue = objectArray[0][property];
		for(const obj of objectArray)
		{
			if(obj[property] != theValue) return false;
		}
		return true;
	}

	public getAvailableStatus() 
	{
		if(this.isNew) return this.newIssueStatusesAvailable;
		const canStatus = this.checkPermittedAttrForEdit('status');
		if(!canStatus) return [];
		const allPermittedStatus = _.map(this.editIssues, 'permittedStatuses');
		const availableStatus  = _.intersection(...allPermittedStatus);
		return availableStatus;
	}

	public interSectionCustomerAttrs() 
	{
		if(this.isNew) return [];
		if(!this.editIssues.length)return [];
		const allCustomAttributes= _.map(this.editIssues, 'customAttributes');
		const allCustomAttributeIds= allCustomAttributes.map(attrs => _.map(attrs, 'attributeDefinitionId'));
		let ids =  _.intersection(...allCustomAttributeIds);

		//check allow edit?
		const customAttrsAllowEdit = this.model.issueAttributeDefinitions.filter(attrDefinition => attrDefinition.permittedActions.includes('edit'));
		if(!customAttrsAllowEdit.length)return [];
		ids = ids.map(id => {
			if(customAttrsAllowEdit.find(c => c.id == id)) return id;
		}).filter(d => d);
		let output:any[] = [];
		const attrs = this.editIssues[0].customAttributes;
		if(attrs)
		{
			output = ids.map((i:string) => attrs.find(a => a.attributeDefinitionId == i));			
		}
		return output;
	}

	public getCustomAttrList(obj: {attributeDefinitionId: string, title: string, type: string, value: string})
	{
		const theCustomAttr =  this.model.issueAttributeDefinitions.find(attr => attr.id == obj.attributeDefinitionId);
		if(theCustomAttr)
		{
			return theCustomAttr.options	
		}
		return [];
	}

	public isCustomAttrUpdated()
	{
		for(const editIssue of this.editIssues)
		{
			if(!_.isEqual(_.sortBy(editIssue.clone.customAttributes), _.sortBy(editIssue.customAttributes)))
				return true;
		}
		return false;
	}

	public getCustomAttrMaxInput(type: string)
	{
		if(type == 'text')return 250;
		if(type == 'numeric')return 15;
		if(type == 'paragraph')return 2500;
		return 255;
	}

	public getCustomAttrInputType(type: string)
	{
		if(type == 'text')return 'text';
		if(type == 'numeric')return 'number';
		if(type == 'paragraph')return 'textarea';
		return 'text';
	}
	
	public getCustomAttrTitle(customAttr)
	{
		if(customAttr && customAttr.title) return customAttr.title;
		return '';
	}

}
